module.exports = __webpack_public_path__ + "img/1366956841.f3ca5053.jpg";